import { useCallback, useEffect, useMemo, useState } from "react"
import { Button } from "../../../components/button/Button"
import styles from "./adminusers.module.css"
import { useLocation } from "wouter"
import { Worker } from "../../../../types"
import { EditUser } from "./EditUser"
import { useWatcher } from "../../../lib/state/useWatcher"
import { tenantState } from "../../../store/tenant"
import { createColumns } from "./usersTableColumns"
import { DataTable } from "@/components/dataTable/DataTable"
import { usersApi } from "@/fetch/api/users"
import { userState } from "@/store/user"

export const AdminUsers = () => {
  const {
    settings: { features },
  } = useWatcher(tenantState)
  const user = useWatcher(userState)
  const [, setLocation] = useLocation()
  const [editRow, setEdit] = useState<undefined | Worker>()
  const [tableItems, setTableItems] = useState<Worker[]>([])

  const init = useCallback(async () => {
    try {
      const data = await usersApi.getWorkers()
      if (data.items) {
        setTableItems(data.items)
      }
    } catch (err) {
      console.error(err)
    }
  }, [])

  useEffect(() => {
    init()
  }, [])

  const onClose = (updated?: boolean) => {
    setEdit(undefined)
    updated && init()
  }

  const onEditUser = useCallback(
    async (data: Worker) => {
      if (editRow?.id) {
        await usersApi.updateUser(editRow?.id, data)
      }
      onClose(true)
    },
    [onClose, editRow]
  )

  const columns = useMemo(
    () =>
      createColumns({
        userRole: user.role,
        setEdit: (e, row) => {
          e.preventDefault()
          setEdit({ ...row })
        },
      }),
    [setEdit, user?.role]
  )

  return (
    <>
      <div className={styles.addBtnWrap}>
        <Button onClick={() => setLocation("/create")}>
          Pievienot darbinieku
        </Button>
      </div>
      <DataTable columns={columns} data={tableItems} searchFields={["name", "username", "email"]} />
      <EditUser
        data={editRow}
        onClose={onClose}
        onEditUser={onEditUser}
        features={features}
      />
    </>
  )
}
